// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__e8Bjt","requiredAsterisk":"Info_requiredAsterisk__1bk27"};